module.exports = __webpack_public_path__ + "img/9788956371856.d264e375.jpg";